import React from 'react'
import Portfoliopage from '../Components/Portfoliopage'
import Footer from '../Components/Footer'

function Portfolio() {
  return (
    <div>
       <Portfoliopage/>
       <Footer/>
    </div>
  )
}

export default Portfolio
